export function emitEvent(eventName, payload) {
    var event = new CustomEvent(eventName, {
        detail: payload
    });
    document.dispatchEvent(event);
}
